import { useState } from "react";
import type { AlbumManifest } from "../data/manifest";
import { JoinCode } from "./JoinCode";
import { startCheckout } from "../data/checkout";

/** End panel — one added colophon, then the primary actions. Mobile shows
 *  stacked full-width CTAs + join code (PRD §3). "Add your photos" opens the
 *  app; "Get it printed" mints a Stripe Checkout Session (Anvil slice-2),
 *  gated on print.available. */
export function Colophon({
  manifest,
  onContribute,
}: {
  manifest: AlbumManifest;
  onContribute: () => void;
}) {
  const printAvailable = manifest.print.available;
  const [busy, setBusy] = useState(false);
  const getPrinted = () => {
    if (!printAvailable || busy) return;
    setBusy(true);
    startCheckout(manifest.id).catch(() => setBusy(false));
  };
  return (
    <section className="colophon" aria-label="The end">
      <p className="label">The end</p>
      <h2 className="colophon__title">{manifest.title}</h2>
      <p className="colophon__meta">
        {manifest.pageCount} pages · made by {manifest.sender.name}
      </p>

      {/* Contribute leads (lavender primary), print = warm-ink secondary. */}
      <div className="colophon__cta">
        <button className="btn btn--primary" type="button" onClick={onContribute}>
          Add your photos
        </button>
        <button
          className="btn btn--ink"
          type="button"
          disabled={!printAvailable || busy}
          onClick={getPrinted}
        >
          {busy ? "Preparing…" : "Get it printed"}
          {!printAvailable && <span className="btn__hint">not enough photos yet</span>}
        </button>
      </div>

      <div className="colophon__join">
        <JoinCode code={manifest.joinCode} />
        <p className="colophon__join-hint">
          Get the Minnea app, then paste this code to add your photos.
        </p>
      </div>
    </section>
  );
}
